"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectExpressionKeysTransformerCustomNode = void 0;
var ObjectExpressionKeysTransformerCustomNode;
(function (ObjectExpressionKeysTransformerCustomNode) {
    ObjectExpressionKeysTransformerCustomNode["ObjectExpressionVariableDeclarationHostNode"] = "ObjectExpressionVariableDeclarationHostNode";
})(ObjectExpressionKeysTransformerCustomNode || (exports.ObjectExpressionKeysTransformerCustomNode = ObjectExpressionKeysTransformerCustomNode = {}));
